<template>
    <div class="popup">
        <div class="popup-content">
            <div>
                <div class="header-pfnr">
                    <strong>
                        <i18n-t keypath="orderApprovePopup.proformaNumber" />
                    </strong>
                    <strong>&nbsp;:&nbsp;</strong>
                    <i18n-t
                        v-if="
                            approveOrders?.[0]?.backoffice_reference == undefined ||
                            approveOrders?.[0]?.backoffice_reference == null
                        "
                        keypath="myOrders.notYetAvailable"
                    />
                    <span v-else>
                        {{ approveOrders?.[0]?.backoffice_reference }}
                    </span>
                    <div>
                        <img
                            src="/img/close-btn.svg"
                            class="close-popup-btn"
                            @click="closePopup"
                        />
                    </div>
                </div>
                <div class="pdf-container">
                    <PdfApp
                        v-show="pdf !== ''"
                        @pages-rendered="pagesRendered"
                        :page-number="pdfPage"
                        :pdf="pdf"
                        pageScale="page-height"
                        style="height: 100vh; width: 80vh"
                        :config="pdfConfig"
                    ></PdfApp>
                </div>
            </div>
            <div class="block2">
                <div class="question">
                    <span class="question-text">
                        <i18n-t keypath="orderApprovePopup.approveQuestion" />
                    </span>
                    <div
                        class="agree-checkbox"
                        v-tippy="{
                            content: i18n.t('myOrders.checkBoxTip'),
                            placement: 'top',
                        }"
                    >
                        <Checkbox
                            v-model="isAgree"
                            :binary="true"
                            @change="isAgree"
                            :disabled="!isFinishedViewingPdf"
                        />
                        <span class="agree-text">
                            <i18n-t keypath="orderApprovePopup.checkBoxText" />
                        </span>
                    </div>
                </div>
                <div class="content">
                    <div class="contact-info">
                        <span class="contact-text">
                            <i18n-t keypath="orderApprovePopup.contactInfo" />
                        </span>
                    </div>
                    <div class="person-info-container">
                        <div class="person-details">
                            <div class="detail-name">
                                {{
                                    `${approveOrders?.[0]?.account_manager?.firstname} ${approveOrders?.[0]?.account_manager?.lastname}`
                                }}
                            </div>
                            <div class="detail-email">
                                Email: {{ approveOrders?.[0]?.account_manager?.email }}
                            </div>
                            <div class="detail-phone">
                                Phone: {{ approveOrders?.[0]?.account_manager?.phone }}
                            </div>
                        </div>
                    </div>
                    <div class="button-container">
                        <div>
                            <button class="cancel-button" @click="closePopup">
                                <i18n-t keypath="orderApprovePopup.cancelButton" />
                            </button>
                        </div>
                        <div>
                            <button
                                :disabled="!isAgree"
                                :class="{ 'app-disabled': !isAgree }"
                                class="approve-button uppercase"
                                @click="approve()"
                            >
                                <i18n-t keypath="orderApprovePopup.approveButton" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped>
:global(:root) {
    --popup-header-height: 34px;
}
.popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-content {
    position: relative;
    gap: 20px;
    height: 98%;
    padding-left: 20px;
    padding-top: 20px;
    background: rgba(247, 249, 251, 1);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-radius: 4px;
}

.header-pfnr {
    margin-bottom: 20px;
    line-height: var(--popup-header-height);
    letter-spacing: 0.01em;
    text-align: left;

    font-family: var(--font-family);
    font-size: 28px;
    font-weight: 500;
    letter-spacing: 0.01em;
    text-align: left;
}

.pdf-container {
    height: calc(97% - var(--popup-header-height));
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow-y: auto;
}

.block2 {
    background: rgba(255, 255, 255, 1);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: -20px;
}

.content {
    padding-left: 20px;
    padding-right: 20px;
}

.question {
    padding-left: 20px;
    padding-top: 50px;
}

.question-text {
    font-size: 24px;
    font-weight: 500;
    line-height: 30px;
    letter-spacing: 0;
    text-align: left;
}

.agree-checkbox {
    width: 256px;
    height: 18px;
    top: 98px;
    left: 975px;
    display: flex;
    align-items: center;
    padding-top: 20px;
}

.checkbox-style {
    width: 18px;
    height: 18px;
    padding-bottom: 24px;
    border-radius: 4px;
}

.agree-text {
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0;
    padding-left: 7px;
    text-align: left;
}

.contact-info {
    padding-top: 408px;
    left: 975px;
}

.contact-text {
    font-size: 15px;
    font-weight: 400;
    line-height: 26px;
    letter-spacing: 0em;
    text-align: center;
    color: rgba(98, 118, 144, 1);
}

.person-info-container {
    display: flex;
    gap: 16px;
    width: 359px;
    height: 108px;
    top: 183px;
    left: 32px;
    padding: 14px;
    text-align: center;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    margin-top: 20px;
}

.person-image img {
    width: 73px;
    height: 74px;
    border-radius: 4px;
}

.person-details {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.detail-name {
    width: 73px;
    height: 11px;
    font-size: 15px;
    font-weight: 600;
    line-height: 25px;
    letter-spacing: 0;
    text-align: left;
    color: rgba(40, 55, 71, 1);
    text-wrap: nowrap;
}

.detail-email {
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0;
    text-align: left;
    color: rgba(98, 118, 144, 1);
}

.detail-phone {
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0;
    text-align: left;
    color: rgba(98, 118, 144, 1);
    margin-top: -10px;
}

.button-container {
    display: flex;
    justify-content: space-around;
    bottom: 10px;
    left: 0;
    right: 0;
    border-top: 1px solid rgba(228, 234, 240, 1);
    padding-top: 20px;
    height: 80px;
}

.button-container button {
    width: 116px;
    height: 40px;
    padding: 10px;
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: 0;
    text-align: center;
    text-transform: uppercase;
    border-radius: 4px;
    transition: transform 0.3s ease;
}

.cancel-button {
    color: rgba(26, 160, 225, 1);
    background: white;
    border: 1px solid rgba(26, 160, 225, 1);
}

.approve-button {
    color: white;
    background: rgba(26, 160, 225, 1);
    border: none;
}

.button-container button:hover {
    transform: scale(1.1);
}
</style>

<script lang="ts">
import { OrderApprovePopup } from "@/dashboard/my-orders/new-popup/order-approve-popup/order-approve-popup";
import { i18n } from "@/shared/i18n/i18n";

export default OrderApprovePopup;
</script>
